import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade , Thumbs } from 'swiper/modules';
import 'swiper/css/bundle';
import AOS from 'aos';
import 'aos/dist/aos.css';

Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Thumbs]);
window.Swiper = Swiper;

// JavaScript
$(document).ready( function () {
  AOS.init({
    once: true // 只在載入時執行一次
  });
  //scroll top
  // $('.back-to-top').click(function(event){
  //   $("html,body").animate({scrollTop: 0}, 1000);
  // });

  // transparent header
  function headerScroll() {
    if ($(window).scrollTop() > 100) {
      $('.header').addClass("min-header");
    } else {
      $('.header').removeClass("min-header");
    }
  }
  headerScroll();
  $(window).on('scroll', function () {
    headerScroll();
  });

  $('.header-mobile-menu').on('click', function () {
    $(this).toggleClass('active');
    $('.header-menu-outer').toggleClass('active');
  });

  $('.menu-link').on('click', function(){
    $('.header-menu-outer').removeClass('active');
    $('.header-mobile-menu').removeClass('active');
  });

  $('.menu-link').click(function(e) {
      $(this).parent().toggleClass('active').siblings().removeClass('active');
  });

  var indexBanner = new Swiper('#indexBanner', {
    effect: 'fade',
    autoplay: {
      delay: 5000,
    },
    loop: true,
    speed: 1000,
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
  });

  // dropdown
  $('.dropdown-btn').on('click', function () {
    const id = $(this).attr('id');
    const dropdown_is_active = $('[aria-labelledby=' + id + ']').hasClass("is-active");
    if (dropdown_is_active >= 1) {
      $('[aria-labelledby=' + id + ']').removeClass('is-active');
      if (window.innerWidth <= 640) {
        $('body').css({
          'height': '',
          'overflow': '',
        })
      }
    } else {
      $(".dropdown-list:not([aria-labelledby=" + id + "]").removeClass('is-active');
      $('[aria-labelledby=' + id + ']').addClass('is-active');
      if (window.innerWidth <= 640) {
        $('body').css({
          'height': '100vh',
          'overflow': 'hidden',
        })
      }
    }
  });

  $(document).click(function (event) {
    if (!$(event.target).closest('.dropdown-btn').length) {
      if ($('.dropdown-list').is(":visible")) {
        $(".dropdown-list").removeClass('is-active');
        if (window.innerWidth <= 640) {
          $('body').css({
            'height': '',
            'overflow': '',
          })
        }
      }
    }
  });

  // 五大求職力 tab 切換顯示
  const strengthTabs = $('.strength-tab');
  const strengthContents = $('.strength-content');

  strengthTabs.on('click', function(){
    // 移除全部 active 樣式
    strengthTabs.removeClass('active');
    strengthContents.removeClass('active');

    // 重設所有 aira-selected 為 false
    strengthTabs.attr('aria-selected', 'false');

    // 將被點擊的 tab 設為 active 並更新 aria-selected
    $(this).addClass('active');
    $(this).attr('aria-selected', 'true');

    // 顯示對應內容區塊
    let activedId = $(this).attr("id");
    let targetId = activedId.replace("strength", "content");
    $('#' + targetId).addClass('active');
  });

  // 明星講師 Swiper
  var lectureSwiper = new Swiper(".lecture-card-swiper", {
    slidesPerView: 1,
    spaceBetween: 6,
    breakpoints: {
      800: {
        slidesPerView: 3,
        spaceBetween: 12,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  // 前台表單驗證
  const contactForm = $('#contactForm');
  const contactSubmitBtn = $('#contactSubmit');

  contactSubmitBtn.on('click', function(e){
    const inputName = $('#contact_name');
    const inputPhone = $('#contact_phone');
    const inputEmail = $('#contact_email');
    const selectCategory = $('#contact_category');
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if(inputName.val().trim() === "") {
      e.preventDefault();
      alert("你尚未填寫姓名");
      inputName.trigger('focus');
      return;
    }
    if(inputPhone.val().trim() === "") {
      e.preventDefault();
      alert("你尚未填寫電話號碼");
      inputPhone.trigger('focus');
      return;
    }
    if(inputEmail.val().trim() === "") {
      e.preventDefault();
      alert("你尚未填寫Email");
      inputEmail.trigger('focus');
      return;
    }
    if (!emailRegex.test(inputEmail.val().trim())) {
      e.preventDefault();
      alert("Email 格式不正確");
      email.trigger('focus');
      return;
    }
    if(selectCategory.val().trim() === "") {
      e.preventDefault();
      alert("你尚未選擇問題類型");
      selectCategory.trigger('focus');
      return;
    }
  })

  // 明星講師
  const lectureCards = $('.lecture-card-outer');
  const closeBtn = $('.close-btn');
  const blackLayout = $('.lecture-black-layout');

  $('.lecture-card-outer').on('click', function(){
    $(this).addClass('active');
    blackLayout.addClass('active');
  });

  closeBtn.on('click', function(e) {
    e.stopPropagation();
    lectureCards.removeClass('active');
    blackLayout.removeClass('active');
  });

  blackLayout.on('click', function(){
    if($('.lecture-card-outer').hasClass('active')) {
      lectureCards.removeClass('active');
      blackLayout.removeClass('active');
    }
  });
});

